import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ClassFilterTrigger } from "@components/Class/ClassFilter/ClassFilterTrigger";
import { GLViewRow } from "../glViewTypes";

export const GLClassCell = React.memo(function GLClassCell({
    row,
}: CellContext<ViewTableFeatures, GLViewRow, unknown>): React.ReactElement {
    const { rowKind, transaction } = row.original;

    if (
        rowKind !== "transaction" ||
        !transaction ||
        transaction.classIds.length === 0
    ) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <ClassFilterTrigger value={transaction.classIds} />
        </ViewTableCell>
    );
});
